import { Component, EventEmitter, Output } from '@angular/core';
import { Globals } from '../services/globals';
import { Router } from '@angular/router';
import { BroadcastService } from '../services/broadcast.service';
import { MatDialog } from '@angular/material/dialog';
import { AppointmentDetailsComponent } from '../client/appointment-details/appointment-details.component';
import { AuthPayload, TutorialVideo } from '../engine/models/models';
import { BehaviorSubject } from 'rxjs';
import { AuthenticationService } from '../services/authenticate.service';
import { Utilities } from '../helpers/utilities';
import { CartDetailsComponent } from '../client/cart-details/cart-details.component';
import { Loader, NgxUiLoaderService } from 'ngx-ui-loader';
import { FaqComponent } from '../client/faq/faq.component';
import { Option } from '../engine/models/models';
import { ExportPicturesService } from '../services/export-pictures.service';
import { ToastrService } from 'ngx-toastr';
import { VideoComponent } from '../client/video/video.component';
import { VideoLibraryComponent } from '../client/video-library/video-library.component';
import { environment } from '../../environments/environment';
import { timeDifferenceCalculator } from 'time-difference-calculator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { VideoType } from '../enum';
import { GroupedOptionsModalComponent } from '../client/grouped-options-modal/grouped-options-modal.component';
import { GroupedOptionsModel, TagGroup } from '../models/GroupedOptionsModel';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.css']
})

export class AppHeaderComponent {
  title = 'app-header';
  isLogIn = false;
  userEmail = "";
  session: any;
  utilities: Utilities = new Utilities();
  isAdminLogin = false;
  showAdminOption = false;
  userData = new BehaviorSubject<AuthPayload>(new AuthPayload());
  isImpersonating: string;

  @Output() onOptionSelected = new EventEmitter<Option>();

  constructor(private authenticationService: AuthenticationService,
    private router: Router,
    private broadcastService: BroadcastService,
    public dialog: MatDialog,
    public globals: Globals,
    private toastr: ToastrService,
    public exportPicturesService: ExportPicturesService,
    public ngxUiLoaderService: NgxUiLoaderService,
    private snackBar: MatSnackBar) {
    if (this.globals.isImpersonating) {
      this.showAdminOption = true;
    }

    let userEmail = localStorage.getItem("userEmail");
    if (this.userEmail) {
      this.isLogIn = true;
      this.userEmail = userEmail;
      this.broadcastService.subscribe("EVENT", (userName) => {
        this.userEmail = userEmail;
      });
    }

    this.isAdminLogin = JSON.parse(localStorage.getItem("userType")).isAdmin;
  }

  get isDesktop(): boolean {
    return window.innerWidth > 800;
  }

  get getLastSavedTime(): string {
    let date = new Date(this.globals.lastSaveCompletedOn);
    let message = timeDifferenceCalculator(date).replace('.', '');
    return message == "00 mins ago" ? "just now" : message;
  }

  openDialog() {
    const dialogRef = this.dialog.open(AppointmentDetailsComponent, {
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      return;
    });
  }

  openVideoLibraryDialog() {
    this.snackBar.dismiss();
    //set height for video player
    localStorage.setItem('windowHeight', (window.innerHeight - 60).toString())
    const videoDialog = this.dialog.open(VideoLibraryComponent, {
      disableClose: true
    });
    videoDialog.afterClosed().subscribe(result => {
      this.globals.showNotificationPanel();
      return;
    });
  }


  openCartDialog() {
    const cartDialog = this.dialog.open(CartDetailsComponent, {
      disableClose: true,
      minWidth: '80%'
    });

    cartDialog.componentInstance.onOptionSelected.subscribe(option => {
      this.onOptionSelected.emit(option);
      cartDialog.close();
    });

    cartDialog.afterClosed().subscribe(result => {
      return;
    });

    this.showTutorial();
  }


  showTutorial() {
    const video = this.globals.appointment.tutorialVideos.find(x => x.videoType == VideoType.Cart);
    if (video && !video.isWatched) {
      if (!this.globals.isImpersonating) {
        video.disableClose = true;
        video.showNotifictaion = true;
        this.openVideoDialog(video)
      }
    }
  }

  openVideoDialog(video: TutorialVideo) {
    this.globals.selectedVideo = video;
    //set height for video player
    localStorage.setItem('windowHeight', (window.innerHeight - 60).toString())
    const videoDialog = this.dialog.open(VideoComponent, { minWidth: '98%', disableClose: true });
    videoDialog.afterClosed().subscribe(result => { return; });
  }

  openFAQ() {
    const faqDoalog = this.dialog.open(FaqComponent, {
      disableClose: true,
      minWidth: '80%'
    });
    faqDoalog.afterClosed().subscribe(result => {
    });
  }

  logout() {
    if (!this.isAdminLogin) {
      this.globals.saveDataIfApplicable();
    }
    this.authenticationService.logout();
  }

  redirect() {
    this.isAdminLogin = JSON.parse(localStorage.getItem("userType")).isAdmin;
    if (this.isAdminLogin) {
      if (this.router.url.includes('/gallery')) {
        window.location.reload();
      }
      else {
        this.router.navigate(["/gallery"]);
      }
    }
    else {
      window.location.reload();
    }
  }

  showModal() {
    var pinnable = this.globals.engine.displayedOptions.filter(q => q.isPinnable);
    this.showGroupedOptionsModal(pinnable);
  }

  showGroupedOptionsModal(options: Option[]) {

    // Should come from database
    var tagOptions = this.globals.engine.optionTags;
    console.log(tagOptions);
    let tagGroups: TagGroup[] = []
    for (let tag of tagOptions) {
      if (tag.tagName.startsWith("PIN ")) {
        if (!tagGroups.some(x => x.tagDisplayName == tag.displayName)) {
          let tagModel: TagGroup = {
            displayOrder: tag.displayOrder,
            tagDisplayName: tag.displayName,
            tagName: tag.tagName
          }
          tagGroups.push(tagModel)
        }
      }
    }

    let model: GroupedOptionsModel = {
      groups: tagGroups,
      options: options
    }
    const modal = this.dialog.open(GroupedOptionsModalComponent, { minWidth: '80%', data: model });
    modal.afterClosed().subscribe(result => { });
  }
}
